var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 177,
    viewBox: "0 0 108 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5232 77.5605L54.8794 75.4553C60.9567 39.2164 91.6714 42.374 97.7639 43.3752C98.6642 43.5232 99.1661 43.6455 99.1661 43.6455L100.946 44.0691L100.783 45.8927C100.722 46.5545 99.1533 62.2338 87.0003 71.7153C79.243 77.7741 69.021 79.8464 56.6239 77.8943L54.5232 77.5605Z",
    fill: "url(#paint0_linear_10664_10869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5186 78.8162L39.4014 78.6408C26.9168 77.5882 17.4855 73.1387 11.3686 65.397C1.79134 53.285 3.93976 37.6527 4.0352 36.9943L4.29786 35.1809L6.13042 35.1932C6.13042 35.1932 6.64623 35.1937 7.5492 35.2637C13.7028 35.7408 44.255 39.9827 41.6712 76.6839L41.5186 78.8162Z",
    fill: "url(#paint1_linear_10664_10869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2568 176.779V64.1631C67.927 64.1406 67.6028 64.1406 67.2729 64.1406H34.3564V176.779H68.2568ZM25.9204 176.779H34.3564V64.1631H34.1719C20.5312 64.1631 8.55652 75.3639 7.5726 89.04L2.96049 151.93C1.94862 165.578 12.2853 176.779 25.9204 176.779ZM75.5188 176.779C89.1595 176.779 99.4906 165.578 98.4844 151.902L93.8667 89.0175C92.8827 75.6733 81.4503 64.6863 68.2345 64.1631V176.779H75.5188Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10664_10869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 5,
    width: 36,
    height: 62
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3774 5.29297L70.3339 8.08039L65.0249 66.3172L35.0684 63.5298L40.3774 5.29297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10664_10869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1085 64.064L47.8271 62.358C40.2683 52.2988 37.2821 42.265 38.9503 32.5344C41.5604 17.2979 54.6045 8.51714 55.161 8.15588L56.6856 7.14318L57.8968 8.52754C58.339 9.0245 68.6235 20.9746 67.1565 36.3664C66.2208 46.1964 60.7168 55.0768 50.7959 62.7614L49.1085 64.064Z",
    fill: "url(#paint2_linear_10664_10869)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10664_10869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 56,
    width: 45,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9697 56.4434H97.5416V100.29H53.9697V56.4434Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10664_10869)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10664_10869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 56,
    width: 45,
    height: 45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7615 56.4531C63.7253 56.4531 53.9756 66.2644 53.9756 78.3765C53.9756 90.483 63.7253 100.3 75.7615 100.3C87.7922 100.3 97.5475 90.483 97.5475 78.3765C97.5475 66.2644 87.7922 56.4531 75.7615 56.4531Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10664_10869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9756 56.4531H97.5475V100.3H53.9756V56.4531Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10664_10869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 44,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.337891 56.4453H43.9098V100.292H0.337891V56.4453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10664_10869)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10664_10869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 44,
    height: 45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1297 56.4551C10.0935 56.4551 0.34375 66.2663 0.34375 78.3785C0.34375 90.485 10.0935 100.302 22.1297 100.302C34.1603 100.302 43.9157 90.485 43.9157 78.3785C43.9157 66.2663 34.1603 56.4551 22.1297 56.4551Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10664_10869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 56.4551H43.9157V100.302H0.34375V56.4551Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7412 64.668C68.2333 64.668 62.1509 70.7887 62.1509 78.3441C62.1509 85.8938 68.2333 92.0145 75.7412 92.0145C83.2436 92.0145 89.326 85.8938 89.326 78.3441C89.326 70.7887 83.2436 64.668 75.7412 64.668Z",
    fill: "#3D1F1E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1104 64.668C14.6024 64.668 8.52002 70.7887 8.52002 78.3441C8.52002 85.8938 14.6024 92.0145 22.1104 92.0145C29.6128 92.0145 35.6952 85.8938 35.6952 78.3441C35.6952 70.7887 29.6128 64.668 22.1104 64.668Z",
    fill: "#3D1F1E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7101 73.9644C76.7101 71.1305 74.4233 68.8331 71.6024 68.8331C68.7814 68.8331 66.4946 71.1305 66.4946 73.9644C66.4946 76.7983 68.7814 79.0957 71.6024 79.0957C74.4233 79.0957 76.7101 76.7983 76.7101 73.9644Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.984 73.9644C30.984 71.1305 28.6972 68.8331 25.8763 68.8331C23.0554 68.8331 20.7686 71.1305 20.7686 73.9644C20.7686 76.7983 23.0554 79.0957 25.8763 79.0957C28.6972 79.0957 30.984 76.7983 30.984 73.9644Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0238 112.196C49.7942 107.388 35.3301 111.59 30.775 114.249C30.2487 114.556 29.8847 115.067 29.7232 115.654C28.4531 120.274 27.1959 131.351 41.4851 130.155C58.0282 128.77 64.4702 132.721 69.5779 123.741C73.6641 116.557 69.1521 113.051 67.0238 112.196Z",
    fill: "#3D1F1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0786 129.973C37.0088 122.506 58.9468 123.362 68.6368 125.306C67.474 126.473 66.3112 129.973 59.3344 129.973C45.3809 129.973 39.567 131.14 36.0786 129.973Z",
    fill: "#FA5B5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10664_10869",
    x1: 81.0724,
    y1: 40.632,
    x2: 74.4647,
    y2: 80.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10664_10869",
    x1: 24.3956,
    y1: 36.5698,
    x2: 21.2422,
    y2: 77.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10664_10869",
    x1: 56.6884,
    y1: 7.14355,
    x2: 48.9582,
    y2: 64.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoConfig);
export default __webpack_public_path__ + "static/media/pikkoConfig.e0a1615c49aea05bdd5e844748788c0a.svg";
export { ForwardRef as ReactComponent };